/* tslint:disable */
/* eslint-disable */
/**
 * GLC.Portal.Api (local) Portal BFF
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 2.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { IAPYESORNO } from './IAPYESORNO';
import {
    IAPYESORNOFromJSON,
    IAPYESORNOFromJSONTyped,
    IAPYESORNOToJSON,
} from './IAPYESORNO';
import type { WithholdingTaxDeclarationViewModel } from './WithholdingTaxDeclarationViewModel';
import {
    WithholdingTaxDeclarationViewModelFromJSON,
    WithholdingTaxDeclarationViewModelFromJSONTyped,
    WithholdingTaxDeclarationViewModelToJSON,
} from './WithholdingTaxDeclarationViewModel';

/**
 * 
 * @export
 * @interface WithholdingTaxViewModel
 */
export interface WithholdingTaxViewModel {
    /**
     * 
     * @type {IAPYESORNO}
     * @memberof WithholdingTaxViewModel
     */
    exemptedFromDividendWithholdingTax?: IAPYESORNO;
    /**
     * 
     * @type {IAPYESORNO}
     * @memberof WithholdingTaxViewModel
     */
    exemptedFromInterestWithholdingTax?: IAPYESORNO;
    /**
     * 
     * @type {WithholdingTaxDeclarationViewModel}
     * @memberof WithholdingTaxViewModel
     */
    dividendWithholdingTax?: WithholdingTaxDeclarationViewModel;
    /**
     * 
     * @type {WithholdingTaxDeclarationViewModel}
     * @memberof WithholdingTaxViewModel
     */
    interestWithholdingTax?: WithholdingTaxDeclarationViewModel;
}

/**
 * Check if a given object implements the WithholdingTaxViewModel interface.
 */
export function instanceOfWithholdingTaxViewModel(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function WithholdingTaxViewModelFromJSON(json: any): WithholdingTaxViewModel {
    return WithholdingTaxViewModelFromJSONTyped(json, false);
}

export function WithholdingTaxViewModelFromJSONTyped(json: any, ignoreDiscriminator: boolean): WithholdingTaxViewModel {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'exemptedFromDividendWithholdingTax': !exists(json, 'ExemptedFromDividendWithholdingTax') ? undefined : IAPYESORNOFromJSON(json['ExemptedFromDividendWithholdingTax']),
        'exemptedFromInterestWithholdingTax': !exists(json, 'ExemptedFromInterestWithholdingTax') ? undefined : IAPYESORNOFromJSON(json['ExemptedFromInterestWithholdingTax']),
        'dividendWithholdingTax': !exists(json, 'DividendWithholdingTax') ? undefined : WithholdingTaxDeclarationViewModelFromJSON(json['DividendWithholdingTax']),
        'interestWithholdingTax': !exists(json, 'InterestWithholdingTax') ? undefined : WithholdingTaxDeclarationViewModelFromJSON(json['InterestWithholdingTax']),
    };
}

export function WithholdingTaxViewModelToJSON(value?: WithholdingTaxViewModel | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'ExemptedFromDividendWithholdingTax': IAPYESORNOToJSON(value.exemptedFromDividendWithholdingTax),
        'ExemptedFromInterestWithholdingTax': IAPYESORNOToJSON(value.exemptedFromInterestWithholdingTax),
        'DividendWithholdingTax': WithholdingTaxDeclarationViewModelToJSON(value.dividendWithholdingTax),
        'InterestWithholdingTax': WithholdingTaxDeclarationViewModelToJSON(value.interestWithholdingTax),
    };
}

